import { Component, OnInit, ViewChild } from "@angular/core";
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { SelectItem } from "primeng/primeng";
import * as moment from "moment";

import { ActionPlanModalComponent } from "./action-plan-modal/action-plan-modal.component";
import { MessageComponent } from "../shared/component/message/message.component";
import { UnconformityService } from "../shared/service/unconformity.service";
import { ActionPlanService } from "../shared/service/action-plan.service";
import { ListValueService } from '../shared/service/list-value.service';
import { UnconformityModel } from "../shared/model/unconformity.model";
import { ChecklistService } from "../shared/service/checklist.service";
import { ActionPlanModel } from "../shared/model/action-plan.model";
import { CalendarLocale } from "../shared/static/calendar-locale";
import { ChecklistModel } from "../shared/model/checklist.model";
import { AuthService } from "../shared/service/auth.service";
import { UserService } from "../shared/service/user.service";
import { UserModel } from "../shared/model/user.model";

@Component({
  selector: "app-action-plan",
  templateUrl: "./action-plan.component.html",
  styleUrls: ["./action-plan.component.css"],
})
export class ActionPlanComponent implements OnInit {
  @ViewChild(ActionPlanModalComponent)
  actionPlanModal: ActionPlanModalComponent;
  calendarLocale = CalendarLocale;

  values = [];
  users: SelectItem[] = [];
  checklists: SelectItem[] = [];
  unconformities: SelectItem[] = [];
  statusOptions: SelectItem[] = [];

  minDate = new Date("1900/01/01");
  maxDate = new Date("2100/01/01");
  tableStyle = {'width': '150px', 'text-align': 'center'};

  initDate = new Date(moment().subtract(7, "days").startOf("day").format());
  endDate = new Date(moment().endOf("day").format());
  unconformity = new UnconformityModel();
  actionPlans: ActionPlanModel[] = [];
  checklist = new ChecklistModel();
  responsible = new UserModel();
  responsible_b = new UserModel();
  status = "ALL";
  allowLoading = false

  selected: ActionPlanModel;
  lastEvent: any = {};
  totalRecords = 0;
  loading = true;
  user;

  constructor(
    private route: ActivatedRoute,

    private unconformityService: UnconformityService,
    private actionPlanService: ActionPlanService,
    private translateService: TranslateService,
    private checklistService: ChecklistService,
    private listValueService: ListValueService,
    private userService: UserService,
    private authService: AuthService
  ) {}

  @ViewChild(MessageComponent) message: MessageComponent;

  ngOnInit() {
    this.updateFilterParams();
    this.getFilterData();
  }

  updateFilterParams() {
    // .filter((params) => params.checklist_response_id || params.checklist_id)
    this.route.queryParams.subscribe((params) => {
      this.lastEvent.params = {
        action_plan_id: this.route.snapshot.paramMap.get("id"),
        ...this.lastEvent.params,
        ...params,
      };
    });
  }

  getFilterData() {
    this.getUser();
    this.getUsers();

    this.getChecklists();
    this.getListAndValues();
    this.getUnconformities();
  }

  getUser() {
    this.userService.getCurrentUserData().subscribe((user) => {
      this.user = new UserModel(user);
      this.allowLoading = true;
    })
  }

  getUsers() {
    this.userService.getPaginated(0, 1000000, "", "", "").subscribe((data) => {
      this.users.push({
        label: this.translate('select_responsible'),
        value: new UserModel(),
      });

      data["rows"].map((item) => {
        this.users.push({ label: item.name, value: item });
      });
    });
  }

  getChecklists() {
    this.checklistService.getPaginated(0, 1000000, "").subscribe((data) => {
      this.checklists.push({
        label: this.translate('select_checklist'),
        value: new ChecklistModel(),
      });

      data["rows"].map((item) => {
        this.checklists.push({ label: item.name, value: item });
      });
      
    });
  }

  getUnconformities() {
    this.unconformityService.getPaginated(0, 1000000, "").subscribe((data) => {
      this.unconformities.push({
        label: this.translate('select_unconformity'),
        value: new UnconformityModel(),
      });

      data["rows"].map((item) => {
        this.unconformities.push({ label: item.description, value: item });
      });
    });
  }

  getListAndValues() {
    this.loading = true;

    this.values = [];

    this.listValueService.getAll({
      end: 1e+8,
      init: 0,
    })
    .finally(() => {
      this.loading = false;
    })
    .subscribe(({ rows }) => {
        this.values = rows || []
      }
    );
  }

  formatHeaderItems(header_item_responses = []) {
    let responseString = "";

    for (const hir of header_item_responses) {
      let fullResponse = hir.response || "N/A";

      // validation for list type
      if (hir.header_item && hir.header_item.list_id) {
        const value = this.values.find((list) => list.id == hir.response);
        if (value && value.description) fullResponse = value && value.description || "N/A";
      }

      responseString += `${hir.header_item.description}: ${fullResponse}; `;
    }

    return responseString;
  }

  lazy(event) {
    this.loading = true;
    this.actionPlans = [];

    this.lastEvent = { ...event, params: this.lastEvent.params };

    const init = event && event.first ? event.first : 0;
    const end = event && event.rows ? event.rows : 10;
    const isAdmin = this.user.is_admin;

    this.statusOptions = [
      { label: this.translate('all'), value: "ALL" },
      { label: this.translate('pending'), value: "PENDING" },
      { label: this.translate('delayed'), value: "LATE" },
      { label: this.translate('done'), value: "DONE" },
    ]

    this.actionPlanService
      .getPaginatedByUser(init, end, {
        status: this.status,
        checklist: this.checklist.id,
        responsible: this.responsible.id,
        responsible_b: this.responsible_b.id,
        unconformity: this.unconformity.id,
        init_date: moment(this.initDate).format(),
        end_date: moment(this.endDate).endOf("day").format(),

        ...(isAdmin ? {} : { user_id: this.user.id } ),
        ...this.lastEvent.params, // get params from url
      })
      .subscribe((data) => {
        this.totalRecords = data["count"];
        this.actionPlans = data["rows"];
        this.loading = false;
      });
  }

  detailActionPlan(event) {
    this.selected = event.data;

    this.actionPlanModal.actionPlan = event.data;
    this.actionPlanModal.values = this.values;
    this.actionPlanModal.display = true;

    this.actionPlanModal.loadActionPlanData();
  }

  doneActionPlan() {
    this.actionPlanModal.closeModal();
    this.message.success();
    this.lazy(this.lastEvent);
  }

  resetFilter() {
    this.minDate = new Date("1900/01/01");
    this.maxDate = new Date("2100/01/01");
    this.initDate = new Date(
      moment().subtract(7, "days").startOf("day").format()
    );
    this.endDate = new Date(moment().endOf("day").format());
    this.checklist = new ChecklistModel();
    this.responsible = new UserModel();
    this.responsible_b = new UserModel();
    this.unconformity = new UnconformityModel();
    this.status = "ALL";

    this.lazy(null);
  }

  async exportCsv() {
    const apiAddress = await this.authService.getApiIP();

    this.actionPlanService
      .exportCsv({
        init_date: moment(this.initDate).format(),
        end_date: moment(this.endDate).endOf("day").format(),
        checklist: this.checklist.id,
        responsible: this.responsible.id,
        unconformity: this.unconformity.id,
        status: this.status,
      })
      .subscribe(async (data) => {
        window.location.href = apiAddress + data.path;
      });
  }

  translate = (key: string) => this.translateService.instant(key || "invalid");
	tUpper = (key) => this.translate(key).toString().toUpperCase();
	tCap = (key) => this.translate(key).charAt(0).toUpperCase() + this.translate(key).slice(1);

}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/action-plan/action-plan.component.ts